import React from "react";
import { Box, Button, Text, Title } from "@mantine/core";
import filter from "../assets/img/filter.svg";
interface Props {
  Heading: any;
  subHeading: string;
  children: React.ReactNode;
}

const SharedSectionHeader: React.FC<Props> = ({ Heading, subHeading,children }) => {
  return (
    <Box sx={{ marginBottom: "32px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          marginBottom: "24px",
        }}
      >
        <Title
          sx={{
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "30px",
            color: "#262930",
          }}
        >
          {Heading} 
        </Title>
        <Text
          sx={{
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#999999",
          }}
        >
          {subHeading}
        </Text>
      </Box>
      <Box sx={{ marginTop: "24px" }}>{children}</Box>
    </Box>
  );
};

export default SharedSectionHeader;
